__turbopack_context__.v({
  "className": "fontopensansitalic_af4518e0-module__RJxdbq__className",
  "variable": "fontopensansitalic_af4518e0-module__RJxdbq__variable",
});
